import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import router from './router'
import App from './App.vue'
import { useLangStore } from './stores/lang'

const app = createApp(App)
const pinia = createPinia()

// 先使用pinia
app.use(pinia)


// 初始化语言设置
const langStore = useLangStore()
langStore.initLang()

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(ElementPlus)

app.mount('#app')
